import Vue from 'vue';
import Vuex from 'vuex';

const requireContext = require.context('.', true, /\.js$/);
let modules = {};
requireContext
  .keys()
  .filter((path) => path !== './index.js')
  .forEach((path) => {
    const moduleName = path.match(/.*(\/)(\S*).js/)[2];
    if (moduleName === 'index') {
      console.error('store/modules/**下的文件名不能为index');
      return;
    }
    const file = requireContext(path);
    modules[moduleName] = file.default || file;
  });

Vue.use(Vuex);

export default new Vuex.Store({
  ...global,
  modules
});
